import tippy from 'tippy.js';

// Renderer for the "@" mention autocomplete. Builds a Tippy popup listing the users
// returned by the context endpoint. Returns the lifecycle object expected by
// @tiptap/suggestion (onStart/onUpdate/onKeyDown/onExit) — same shape as the merge-tag
// dropdown, reusing the shared .merge-tag-menu styling for a consistent look.
export function createMentionDropdown() {
  let popup;
  let menuElement;
  let items = [];
  let selectedIndex = 0;
  let runCommand;

  function renderList() {
    menuElement.innerHTML = '';

    if (items.length === 0) {
      const emptyState = document.createElement('div');
      emptyState.className = 'merge-tag-menu__empty';
      emptyState.textContent = 'Nenhum usuário encontrado';
      menuElement.appendChild(emptyState);
      return;
    }

    items.forEach((item, index) => {
      const itemButton = document.createElement('button');
      itemButton.type = 'button';
      itemButton.className = `merge-tag-menu__item${index === selectedIndex ? ' is-selected' : ''}`;
      itemButton.innerHTML = '<span class="merge-tag-menu__title"></span>';
      itemButton.querySelector('.merge-tag-menu__title').textContent = item.label;
      itemButton.addEventListener('mousedown', (event) => {
        event.preventDefault();
        runCommand(item);
      });
      menuElement.appendChild(itemButton);
    });
  }

  function selectCurrent() {
    const item = items[selectedIndex];
    if (item) runCommand(item);
  }

  return {
    onStart(props) {
      items = props.items;
      runCommand = props.command;
      selectedIndex = 0;
      menuElement = document.createElement('div');
      menuElement.className = 'merge-tag-menu';
      renderList();

      popup = tippy(document.body, {
        getReferenceClientRect: props.clientRect,
        appendTo: () => document.body,
        content: menuElement,
        showOnCreate: true,
        interactive: true,
        trigger: 'manual',
        placement: 'bottom-start',
        popperOptions: {
          strategy: 'fixed',
          modifiers: [
            { name: 'flip', options: { fallbackPlacements: ['top-start'] } },
            { name: 'preventOverflow', options: { boundary: 'viewport', altAxis: true, padding: 8 } }
          ]
        },
        theme: 'light'
      });
    },

    onUpdate(props) {
      items = props.items;
      runCommand = props.command;
      selectedIndex = 0;
      renderList();
      if (props.clientRect) popup.setProps({ getReferenceClientRect: props.clientRect });
    },

    onKeyDown(props) {
      if (props.event.key === 'Escape') {
        popup.hide();
        return true;
      }
      if (items.length === 0) return false;

      if (props.event.key === 'ArrowDown') {
        selectedIndex = (selectedIndex + 1) % items.length;
        renderList();
        return true;
      }
      if (props.event.key === 'ArrowUp') {
        selectedIndex = (selectedIndex + items.length - 1) % items.length;
        renderList();
        return true;
      }
      if (props.event.key === 'Enter') {
        selectCurrent();
        return true;
      }
      return false;
    },

    onExit() {
      if (popup) popup.destroy();
    }
  };
}
